import { Span } from '@pandiafi/design-system'
import React from 'react'

interface FeeRowProps {
  label: string
  value: string
}

export const FeeRow: React.FC<FeeRowProps> = ({ label, value }) => (
  <div className="flex justify-between gap-4 py-2">
    <Span>{label}</Span>
    <Span className="whitespace-nowrap">{value}</Span>
  </div>
)
